export const EviusUrl = process.env.REACT_APP_EVIUS_URL;
export const ApiUrl = `https://api.evius.co/api/user/loginorcreatefromtoken`;